import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { ref, reactive, useTemplateRef } from "vue";
import { useI18n } from "vue-i18n";
import api from "@/api/examine";
import { ElMessage } from "element-plus";
export default {
  __name: 'examine',
  props: {
    statusList: {
      type: Array,
      default: () => []
    },
    appList: {
      type: Array,
      default: () => []
    }
  },
  emits: "loadList",
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      t
    } = useI18n();
    const emit = __emit;
    const rules = reactive({
      picStatus: [{
        required: true,
        message: t("orderReview.validate.select"),
        trigger: "change"
      }],
      pdfStatus: [{
        required: true,
        message: t("orderReview.validate.select"),
        trigger: "change"
      }],
      videoStatus: [{
        required: true,
        message: t("orderReview.validate.select"),
        trigger: "change"
      }],
      orderStatus: [{
        required: true,
        message: t("orderReview.validate.select"),
        trigger: "change"
      }],
      notes: [{
        required: true,
        message: t("orderReview.validate.input"),
        trigger: "blur"
      }]
    });
    const showDialog = ref(false);
    const loading = ref(false);
    const formRef = useTemplateRef("formRef");
    const paymentStatusOptions = [{
      label: "orderReview.paymentStatus.pendingReview",
      value: 0
    }, {
      label: "orderReview.paymentStatus.failed",
      value: 1
    }, {
      label: "orderReview.paymentStatus.success",
      value: 2
    }, {
      label: "orderReview.paymentStatus.refunded",
      value: 3
    }, {
      label: "orderReview.paymentStatus.pending",
      value: 4
    }, {
      label: "orderReview.paymentStatus.fakeProof",
      value: 5
    }];
    const form = reactive({
      id: "",
      picStatus: "",
      // 图片材料状态：0-待审核;1-付款失败;2-付款成功;3-付款回退;4-付款等待;5-虚假证明;
      pdfStatus: "",
      // PDF材料状态：0-待审核;1-付款失败;2-付款成功;3-付款回退;4-付款等待;5-虚假证明;
      videoStatus: "",
      // 视频材料状态：0-待审核;1-付款失败;2-付款成功;3-付款回退;4-付款等待;5-虚假证明;
      orderStatus: "",
      // 审核状态：1-成功;2-失败;
      notes: "" // L2客服备注
    });
    const rowItem = ref({});
    const open = row => {
      showDialog.value = true;
      form.id = row.id;
      rowItem.value = row;
    };
    const handleClose = () => {
      formRef.value?.resetFields();
      form.id = "";
      form.picStatus = "";
      form.pdfStatus = "";
      form.videoStatus = "";
      form.orderStatus = "";
      form.notes = "";
    };
    const handleExamine = () => {
      formRef.value.validate(async valid => {
        if (!valid) return;
        loading.value = true;
        try {
          const {
            data
          } = await api.examine(form);
          if (data.code !== 0) return;
          ElMessage.success(t("orderReview.result.success"));
          emit("loadList");
        } finally {
          loading.value = false;
          showDialog.value = false;
        }
      });
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: _ctx.$t('orderReview.form.examine'),
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => showDialog.value = $event),
        width: "650px",
        onClose: handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = $event => showDialog.value = false),
          size: "large"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          loading: loading.value,
          onClick: handleExamine
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          model: form,
          "label-width": "120px",
          rules: rules,
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.form.app')
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.appList.find(i => i.id === rowItem.value.platform)?.name || rowItem.value.platform), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.form.userId')
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(rowItem.value.platformUid), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.form.creator')
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(rowItem.value.gmUsername), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.form.utr')
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(rowItem.value.utr), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.table.amount')
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString((rowItem.value.amount / 100).toFixed(2)), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.table.uploadImage'),
            prop: "picStatus"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.picStatus,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.picStatus = $event),
              teleported: false
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(paymentStatusOptions, (item, index) => {
                return _createVNode(_component_el_option, {
                  key: index,
                  value: item.value,
                  label: _ctx.$t(item.label)
                }, null, 8, ["value", "label"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.table.pdf'),
            prop: rowItem.value.pdf ? 'pdfStatus' : ''
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.pdfStatus,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.pdfStatus = $event),
              teleported: false
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(paymentStatusOptions, (item, index) => {
                return _createVNode(_component_el_option, {
                  key: index,
                  value: item.value,
                  label: _ctx.$t(item.label)
                }, null, 8, ["value", "label"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label", "prop"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.table.video'),
            prop: rowItem.value.video ? 'videoStatus' : ''
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.videoStatus,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.videoStatus = $event),
              teleported: false
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(paymentStatusOptions, (item, index) => {
                return _createVNode(_component_el_option, {
                  key: index,
                  value: item.value,
                  label: _ctx.$t(item.label)
                }, null, 8, ["value", "label"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label", "prop"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.table.remark'),
            prop: "notes"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.notes,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.notes = $event),
              maxlength: "200",
              rows: 3,
              type: "textarea",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('orderReview.form.state'),
            prop: "orderStatus"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.orderStatus,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.orderStatus = $event),
              teleported: false
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                value: 1,
                label: _ctx.$t('orderReview.common.success')
              }, null, 8, ["label"]), _createVNode(_component_el_option, {
                value: 2,
                label: _ctx.$t('orderReview.common.failed')
              }, null, 8, ["label"])]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["model", "rules"])])]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }
};